module.exports = __webpack_public_path__ + "static/Pablo-5492d55dbbffbdd2c62093bde2b93251.webp";